import { toQueryParamsString } from '../../utils/ApiUtils';
import { Order } from '../../interfaces/Table';

import { API_BASE_URL } from '../../env';
import { ItemType } from '../../interfaces/api/ActivityWall';
import { ApiReturnType } from '../../interfaces/api/api';

export default {
  getItems: (wallId: string, criteria: Object, orderBy: string, order: Order): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/activity-wall/walls/${wallId}/items${toQueryParamsString({
      ...criteria,
      orderBy,
      order,
    })}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  addItem: (wallId: string, itemType: ItemType, payload: Object, attachments?: File[]): ApiReturnType => {
    const params = new FormData();

    if (attachments) {
      attachments.forEach((attachment) => {
        params.append('attachments[]', attachment);
      });
    }
    params.append('itemType', itemType);

    Object.keys(payload).forEach((key) => {
      params.append(key, payload[key]);
    });

    return {
      endpoint: `${API_BASE_URL}/v2/activity-wall/walls/${wallId}/items`,
      body: params,
      method: 'POST',
    };
  },
  editItem: (wallId: string, itemId: string, payload: Object): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/activity-wall/walls/${wallId}/items/${itemId}`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    method: 'PATCH',
  }),
  removeItem: (wallId: string, itemId: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/activity-wall/walls/${wallId}/items/${itemId}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }),
  addItemAttachment: (wallId: string, itemId: string, file: File): ApiReturnType => {
    const params = new FormData();
    params.append('attachments[]', file);

    return {
      endpoint: `${API_BASE_URL}/v2/activity-wall/walls/${wallId}/items/${itemId}/attachments`,
      body: params,
      method: 'POST',
    };
  },
  removeItemAttachment: (wallId: string, itemId: string, attachmentId: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/activity-wall/walls/${wallId}/items/${itemId}/attachments/${attachmentId}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }),
};
